// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"890123b6","325":"f59579f3","773":"d490df04","924":"b5747365"}[chunkId] + ".chunk.css";
};